import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.601 39.457 8.755-17.51-6.957-.695a1.91 1.91 0 0 1-1.61-2.535L29.213 6.18a.955.955 0 0 0-.9-1.272h-9.047a.955.955 0 0 0-.942.798l-2.876 17.255a2.864 2.864 0 0 0 2.565 3.323l5.483.498a1.91 1.91 0 0 1 1.733 2.013L24.6 39.457Zm-.372 5.013c-.464.929-1.867.554-1.806-.483l.9-15.303-5.482-.498a4.773 4.773 0 0 1-4.276-5.538l2.876-17.255A2.864 2.864 0 0 1 19.266 3h9.047a2.863 2.863 0 0 1 2.7 3.817L26.59 19.352l6.957.696a1.909 1.909 0 0 1 1.518 2.753L24.23 44.471Z",
    fill: "currentColor"
  }));
};

var SvgActivity = styled(SvgComponent).withConfig({
  displayName: "Activity__SvgActivity",
  componentId: "sc-1vjhmes-0"
})(["", " ", ""], size, color);
export default SvgActivity;